<template>
	<el-autocomplete
		style="width: 260px"
		v-model="data.address"
		:fetch-suggestions="querySearchAsync"
		placeholder="请输入停车场"
		@select="handleSelect"
		@change="handleChange"
		clearable
	></el-autocomplete>
</template>

<script>
import { reactive, inject } from "vue";
import { apiUserParkingLotList } from "@/api/requestApis.js";
export default {
	props: {
		data: {
			type: Object,
			default() {
				return {};
			},
		},
	},
	setup(props, context) {
		const updateSearchOption = inject("updateSearchOption", false);
		const handleSearch = inject("handleSearch", false);
		const data = reactive({
			address: "",
		});

		const querySearchAsync = async (val, cb) => {
			const res = await apiUserParkingLotList({
				name: val,
			});
			const list = res.map((item) => {
				return {
					value: item.name,
					...item,
				};
			});
			cb(list);
		};
		const handleSelect = (val) => {
			context.emit("handleChange", val);
			let result = "";
			if (props.data.valueType === "id") {
				result = val.id;
			} else {
				result = val.name;
			}
			updateSearchOption && updateSearchOption(props.data.key, result);
		};
		const handleChange = (val) => {
			updateSearchOption && updateSearchOption(props.data.key, "");
		};

		return {
			data,
			handleChange,
			querySearchAsync,
			handleSelect,
		};
	},
};
</script>

<style lang="scss" scoped>
</style>
